// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1374":"eb4cf552","5710":"eb4cf552"}[chunkId] + ".chunk.css";
};